import request from "@/utils/request";

/**
 * 冀华伙伴
 */
export function customerList() {
    return request({
        url: "/api/customer/list",
        method: "get",
    });
}
